import heroHome from "../../assets/hero-banner-1.webp";
import heroPaymentProcessing from "../../assets/payment-processing-banner.webp";
import heroAgents from "../../assets/agent-application-banner.webp";
import heroIndustries from "../../assets/industry-banner.webp";
import heroRetailPos from "../../assets/retail-pos-banner.webp";
import heroLossPrevention from "../../assets/loss-prevension-banner.webp";
import heroMerchants from "../../assets/merchant-app.webp";
import { getTabFromPath } from "./navConfig";
import { preloadImage } from "../../utils/preloadImage";

/* The hero background of each landing tab — the same files Banner.css uses
   (banner-1 … banner-7). Importing them here resolves to the SAME hashed URL
   webpack gives the CSS, so preloading one never downloads it twice.
   Contact has no hero. */
export const HERO_IMAGE_BY_TAB = {
  home: heroHome,
  "payment-processing": heroPaymentProcessing,
  agents: heroAgents,
  industries: heroIndustries,
  "retail-pos": heroRetailPos,
  "loss-prevention": heroLossPrevention,
  merchants: heroMerchants,
};

/* The hero is a CSS background, which the browser only discovers after the
   lazy LandingPage chunk has downloaded, run and rendered. Called when that
   chunk starts loading, this starts the (above-the-fold) hero download in
   parallel instead of after it. */
export const preloadLandingHero = (pathname) =>
  preloadImage(HERO_IMAGE_BY_TAB[getTabFromPath(pathname)]);
